import { isRouteErrorResponse, useRouteError, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/Button';

/** `errorElement` for the router — handles loader/render errors per route. */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = 'Something went wrong';
  let detail = 'An unexpected error occurred while loading this page.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    const data: unknown = error.data;
    if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string') {
      detail = data.message;
    }
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <div
      role="alert"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center"
    >
      <h1 className="text-h1 font-semibold text-foreground">{title}</h1>
      <p className="max-w-md text-muted">{detail}</p>
      <Button onClick={() => void navigate(0)}>Reload</Button>
    </div>
  );
}
